<template>
  <div
    class="badge"
    :class="[size, { rounded }, { circle }, { fill }, color, customClass]"
  >
    {{ text }}
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: [String, Number],
      required: true,
    },
    size: {
      type: String,
      default: 'md',
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    circle: {
      type: Boolean,
      default: false,
    },
    fill: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
    },
    customClass: {
      type: [String, Object, Array],
    },
  },

};
</script>

<style lang="scss" scoped>
@import "~styles/shared/badges.scss";
</style>
